import AdminRealtimeService from '@/services/admin-realtime.service'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

let unsubscribe = null
let toastHandler = null

function showReviewToast(router, payload) {
  if (!toastHandler) return

  const startName = payload.startName || 'Старт'
  const score = payload.averageScore != null ? Number(payload.averageScore).toFixed(1) : '—'

  toastHandler({
    component: ToastificationContent,
    props: {
      title: 'Новый отзыв',
      text: `${startName}: оценка ${score}/10`,
      variant: 'info',
      icon: 'StarIcon',
    },
    onClick: () => {
      if (router.currentRoute.name !== 'reviews') {
        router.push({ name: 'reviews' })
      }
    },
  })
}

export function initReviewNotifications(router, toast) {
  toastHandler = toast || toastHandler

  if (unsubscribe) {
    AdminRealtimeService.ensureConnected()
    return
  }

  AdminRealtimeService.ensureConnected()
  unsubscribe = AdminRealtimeService.onEvent(evt => {
    if (!evt || evt.type !== 'admin.review.new') return
    showReviewToast(router, evt.payload || {})
  })
}

export function destroyReviewNotifications() {
  if (unsubscribe) {
    unsubscribe()
    unsubscribe = null
  }
}
